module.exports = __webpack_public_path__ + "img/enamad-logo.e5dc1a5.svg";